export const CLOSING_CARD =
  'relative rounded-2xl border border-gray-200 bg-white p-4 shadow-bento dark:border-white/10 dark:bg-gray-800 sm:p-5';

/** Lift used by every closing document page, empty or filled. */
export const CLOSING_DOCUMENT_SHADOW =
  'shadow-[0_18px_36px_-12px_rgba(15,23,42,0.48),0_8px_16px_-8px_rgba(15,23,42,0.28)]';

/** One gray field behind steps and the document, as on Sign the Lease. */
export const CLOSING_DOCUMENT_PANEL =
  'mt-3 rounded-xl border border-gray-200 bg-gray-50 px-4 py-4 dark:border-white/10 dark:bg-white/5';

/** Paired upload + document preview (ClosingDocumentUpload). */
export const CLOSING_UPLOAD_PAIR_GRID =
  'mt-3 grid min-h-0 flex-1 grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4';

/** Tall instructions card — room for expanded copy. */
export const CLOSING_UPLOAD_INSTRUCTIONS_CARD =
  'flex min-h-[10rem] flex-col rounded-xl border border-sky-200 bg-sky-50 px-4 py-4 dark:border-sky-900/40 dark:bg-sky-950/30 sm:min-h-[11rem]';

/** Same footprint as utilities instructions, neutral styling for other closing steps. */
export const CLOSING_STEP_INSTRUCTIONS_NEUTRAL =
  'flex min-h-[10rem] flex-col rounded-xl border border-gray-200 bg-gray-50 px-4 py-4 dark:border-white/10 dark:bg-white/5 sm:min-h-[11rem]';

/** Match instructions height on the document column. */
export const CLOSING_UPLOAD_PREVIEW_SHELL =
  `relative flex min-h-[10rem] flex-col overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-white/10 dark:bg-white/5 sm:min-h-[11rem] ${CLOSING_DOCUMENT_SHADOW}`;

/** Dropzone and review-status row share this short height. */
export const CLOSING_UPLOAD_SECONDARY_ROW_MIN = 'min-h-[3.25rem]';

export const CLOSING_UPLOAD_FILE_ROW_MIN = 'min-h-[2.75rem]';

export const CLOSING_BUTTON =
  'inline-flex cursor-pointer rounded-lg bg-gray-900 px-3 py-2 text-sm text-white';

export const CLOSING_BUTTON_DISABLED =
  'inline-flex cursor-not-allowed rounded-lg bg-gray-200 px-3 py-2 text-sm text-gray-500 dark:bg-white/10 dark:text-gray-500';

export function closingStatusClass(done: boolean): string {
  return done
    ? 'font-medium text-emerald-700 dark:text-emerald-300'
    : 'font-medium text-rose-600 dark:text-rose-300';
}
